export const FETCH_COLOCATION_NETWORK_UPLINK = 'FETCH_COLOCATION_NETWORK_UPLINK';

export const FETCH_COLOCATION_NETWORK_UPLINK_IS_PENDING = 'FETCH_COLOCATION_NETWORK_UPLINK_IS_PENDING';

export const FETCH_COLOCATION_NETWORK_UPLINK_IS_ERROR = 'FETCH_COLOCATION_NETWORK_UPLINK_IS_ERROR';

export const FETCH_OVERUSE = 'FETCH_OVERUSE';

export const FETCH_OVERUSE_IS_PENDING = 'FETCH_OVERUSE_IS_PENDING';

export const FETCH_OVERUSE_IS_ERROR = 'FETCH_OVERUSE_IS_ERROR';

export const FETCH_POWER_USAGE = 'FETCH_POWER_USAGE';

export const FETCH_POWER_USAGE_IS_PENDING = 'FETCH_POWER_USAGE_IS_PENDING';

export const FETCH_POWER_USAGE_IS_ERROR = 'FETCH_POWER_USAGE_IS_ERROR';

export const FETCH_POWER_USAGE_CURRENT = 'FETCH_POWER_USAGE_CURRENT';

export const FETCH_POWER_USAGE_CURRENT_IS_PENDING = 'FETCH_POWER_USAGE_CURRENT_IS_PENDING';

export const FETCH_POWER_USAGE_CURRENT_IS_ERROR = 'FETCH_POWER_USAGE_CURRENT_IS_ERROR';

export const FETCH_POWER_USAGE_HISTORY = 'FETCH_POWER_USAGE_HISTORY';

export const FETCH_POWER_USAGE_HISTORY_IS_PENDING = 'FETCH_POWER_USAGE_HISTORY_IS_PENDING';

export const FETCH_POWER_USAGE_HISTORY_IS_ERROR = 'FETCH_POWER_USAGE_HISTORY_IS_ERROR';

export const FETCH_PDU = 'FETCH_PDU_TELEMETRY';

export const FETCH_PDU_IS_PENDING = 'FETCH_PDU_TELEMETRY_IS_PENDING';

export const FETCH_PDU_IS_ERROR = 'FETCH_PDU_TELEMETRY_IS_ERROR';

export const RESET_REDUCER = 'RESET_COLO_TELEMETRY';
